import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import SmallModal from "./modals/SmallModal";

// Tarjeta de reporte — ver design_handoff_crediapp_redesign/Reportes CrediApp.dc.html:
// radio 15px, padding 18px, icono-chip 44x44 radio 12px, titulo Poppins 600 15px
// y pie "Generar →" en verde. Hover: translateY(-3px).
const CallerSelector = ({ icon, text, modalTitle, children }) => {
  const [showModal, setShowModal] = useState(false);

  // Un solo elemento contenedor a proposito: SmallModal siempre renderiza un
  // <div> envolvente aunque este cerrado, asi que devolver un Fragment metia
  // una celda vacia extra por cada tarjeta y la grilla quedaba en damero.
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box
        onClick={() => setShowModal(true)}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          flex: 1,
          backgroundColor: "background.paper",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "15px",
          padding: "18px",
          cursor: "pointer",
          transition: "transform .18s ease, box-shadow .18s ease",
          "&:hover": {
            transform: "translateY(-3px)",
            boxShadow: "0 16px 30px -18px rgba(0,0,0,.35)",
          },
        }}
      >
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: "12px",
            backgroundColor: "rgba(18,163,90,.13)",
            color: "#12a35a",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <FontAwesomeIcon icon={icon} style={{ width: 22, height: 22 }} />
        </Box>

        <Typography
          sx={{
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 600,
            fontSize: 15,
            color: "text.primary",
            lineHeight: 1.3,
          }}
        >
          {text}
        </Typography>

        <Box
          sx={{
            marginTop: "auto",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            color: "#12a35a",
            fontSize: 13,
            fontWeight: 700,
          }}
        >
          Generar
          <ArrowForwardRoundedIcon sx={{ fontSize: 14 }} />
        </Box>
      </Box>

      <SmallModal
        titulo={modalTitle}
        isVisible={showModal}
        setVisible={setShowModal}
      >
        {children}
      </SmallModal>
    </Box>
  );
};

export default CallerSelector;
